<template>
  <div class="limiter">
    <div>
      <loading :active.sync="isLoading" :can-cancel="true" :is-full-page="true"></loading>
    </div>
    <div class="container-login100" style="background-image: url('static/img/img-01.jpg');">
      <div class="wrap-login100">
        <form class="login100-form validate-form" @submit.prevent="checkCreds">
          <div class="login100-form-avatar">
            <img src="static/img/hombre.png" alt="avatar">
          </div>
          <span class="login100-form-title p-t-20 p-b-45">
            Sistema de Mantenimiento de Usuarios
          </span>
          <div class="wrap-input100 validate-input m-b-10" data-validate="Username is required">
            <input class="input100" type="text" placeholder="Usuario" v-model="username">
            <span class="focus-input100"></span>
            <span class="symbol-input100">
              <i class="fa fa-user"></i>
            </span>
          </div>
          <div class="wrap-input100 validate-input m-b-10" data-validate="Password is required">
            <input class="input100" type="password" placeholder="Password" v-model="password">
            <span class="focus-input100"></span>
            <span class="symbol-input100">
              <i class="fa fa-lock"></i>
            </span>
          </div>
          <div class="container-login100-form-btn p-t-10">
            <button class="login100-form-btn">
              Acceder
            </button>
          </div>
          <div class="text-center w-full p-t-25 p-b-100">
            <a href="#" class="txt1" style="color: white">
              {{ response }}
            </a>
          </div>
        </form>
      </div>
    </div>
    <!-- Mostrar mensajes de usuario no autorizado -->
    <div v-if="showUnauthorizedMessage" class="unauthorized-message">
      <p><i class="fa fa-exclamation-circle"></i> {{ unauthorizedMessage }}</p>
    </div>
  </div>
</template>

<script>

import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

import axios from 'axios'
import { apiLOGIN, apiAUTH, apiTOKEN } from '@/store/state'
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
//import App from './App.vue';

export default {
  name: 'Login',
  data(router) {
    return {
      section: 'Login',
      loading: '',
      username: '',
      password: '',
      response: '',
      result: '',
      isLoading: false,
      fullPage: true,
      showUnauthorizedMessage: false,
      unauthorizedMessage: '',
      userRol: []
    }
  },
  beforeCreate: function () {
    if (!this.$session.exists()) {
      this.$router.push('/login')
    } else {
      this.$router.push('/')
    }
  },
  methods: {
    mensaje_bienvenida() {
      Swal.fire({
        icon: 'success',
        //title: `Bienvenido al Sistema <p>${this.username.toUpperCase()}</p>`,
        title: `Bienvenido al sistema <p>${this.$store.state.nombres.toUpperCase()}</p>`,
        text: 'Tribunal Constitucional',
        timer: 1500,
        timerProgressBar: true,
        showConfirmButton: false
      });
    },
    mensaje_noautorizado() {
      Swal.fire({
        icon: 'error',
        title: 'Usuario No Autorizado',
        text: 'No tienes permisos para acceder.',
        timer: 5000, // Duración en milisegundos
        timerProgressBar: true,
        showConfirmButton: false
      });
    },
    mensaje_401() {
      Swal.fire({
        icon: 'error',
        title: 'La sesión ha expirado',
        text: 'Vuelve a iniciar sesión.',
        timer: 4000, // Duración en milisegundos
        timerProgressBar: true,
        showConfirmButton: false,
        willClose: () => {
          // Emite un evento personalizado cuando se cierra el mensaje
          document.dispatchEvent(new Event('swalClosed'));
        }
      });
    },
    checkCreds() {
      this.isLoading = true;
      const { username, password } = this
      this.toggleLoading()
      this.resetResponse()
      this.$store.commit('TOGGLE_LOADING')

      axios.post(
        //'https://tomcat.sedetc.gob.pe/cas-services-0.0.1/login',
        `${apiLOGIN}/login`,

        {
          'username': username,
          'password': password
        }

        /*
        ).then(response => {
          this.toggleLoading()
          this.username = this.username.toLowerCase();
          if(this.username == 'cgarcia' || this.username == 'crodrigueza' || this.username == 'jrodriguez' || this.username == 'lpena' || this.username == 'cespinoza'){
              if (response.status === 200) {
                this.$session.start()
                this.$session.set('user', username)
                this.$session.set('token', response.headers.authorization)
                axios.defaults.headers.common['Authorization'] = this.$session.get('token')
                this.authCarga();
              }else {
                this.isLoading = false;
                this.response = 'Error interno con el servidor'
              }
          }else{
               // this.errorUser();
               this.isLoading = false;
               this.response = 'No cuenta con permisos para acceder'
          }
        })
        */
      ).then(response => {
        this.toggleLoading()
        this.username = this.username.toLowerCase();

        if (response.status === 200) {
          this.$session.start()
          this.$session.set('user', username)
          this.$session.set('token', response.headers.authorization)
          axios.defaults.headers.common['Authorization'] = this.$session.get('token');
          ///////////////////////
          this.getUserData();
          //////////////////////
        } else {
          // this.errorUser();
          this.isLoading = false;
          this.response = 'No cuenta con permisos para acceder'
        }
      })
        .catch(error => {
          this.$store.commit('TOGGLE_LOADING')
          this.isLoading = false;
          this.response = 'Usuario y/o password incorrectos'
          this.toggleLoading()
        })
    },
    //////// Obtener data de usuario (dni y nombres) del API postlogin ////
    getUserData() {
      // axios.get('https://tomcat.sedetc.gob.pe/cas-services-0.0.1/colaboradores/postlogin', {
      axios.get(`${apiLOGIN}/colaboradores/postlogin`, {
        headers: {
          'Authorization': `${this.$session.get('token')}`
        }
      }).then(userResponse => {
        if (userResponse.status === 200 && userResponse.data) {
          const { dni, nombres } = userResponse.data[0];
          this.$store.dispatch('actualizarDatosUsuario', { dni, nombres });

          /////Ejecutando el método getUserRoles//////
          this.getUserRoles();
          /////////////
        } else {
          this.isLoading = false;
          this.response = 'No cuenta con permisos para acceder'
          this.$session.destroy()
          localStorage.clear()
        }
      }).catch(error => {
        this.isLoading = false;
        this.handleError(error);
        this.$session.destroy()
        localStorage.clear()
      })
    },
    /////////// Obtener operaciones de la API de Roles de usuario (GESU) para el sidebar //////    
    getUserRoles() {
      // axios.get('https://tomcat.sedetc.gob.pe/cas-services-0.0.1/operaciones/app/GESU', {
      axios.get(`${apiLOGIN}/operaciones/app/GESU`, {
        headers: {
          'Authorization': `${this.$session.get('token')}`
        }
      }).then(rolResponse => {
        if (rolResponse.status === 200 && rolResponse.data) {
          this.userRol = rolResponse.data;
          // Verificar si el array de roles está vacío
          if (this.userRol.length === 0) {
            this.isLoading = false;
            //console.error('Usuario No Autorizado');
            this.response = 'Usuario No Autorizado'
            // Mostrar mensaje de "Usuario No Autorizado"
            this.mensaje_noautorizado()
            this.$session.destroy();
            localStorage.clear()
            this.$router.push('/login');
            return;
          } else {
            //// API de roles almacenado en userRol            
            this.$store.dispatch('actualizarDatosRol', this.userRol);
            ///////Ejecutando el método authCarga//////////
            this.authCarga();
          }
        } else {
          this.isLoading = false;
          this.response = 'Error en el servidor. Por favor, inténtalo de nuevo más tarde'
          this.$session.destroy();
          localStorage.clear()
          this.$router.push('/login');
        }
      })
        .catch(error => {
          this.handleError(error);
        })
    },
    authCarga() {
      let data =
      {
        'client_id': 'MxzsgeU7uo8lTkIaKYgpwyKrbELw7I5n',
        'client_secret': 'h2beoNKHel6lPKWhDyQ1NJivJz7ugpd5TV9-nwbk6VBdqjFi590dwvitqWgTC4LF',
        //'audience': 'https://tcperu.auth0.com/api/v2/',
        'audience': `${apiAUTH}/`,
        'grant_type': 'client_credentials'
      }
      //axios.post('https://tcperu.auth0.com/oauth/token', data, {header: 'content-type: application/json', crossDomain: true
      axios.post(`${apiTOKEN}`, data, {
        header: 'content-type: application/json', crossDomain: true
      }).then((response) => {
        let token = response.data.access_token;
        let expiresIn = response.data.expires_in; ///tiempo de expiración 14400 seg. (4 horas)        

        // Obtener el timestamp actual en formato fecha y hora        
        let currentTime = new Date().toLocaleString('es-PE', { timeZone: 'America/Lima' });
        // Sumar el expiresIn al timestamp actual para obtener el nuevo timestamp de expiración en formato fecha y hora
        let expirationTime = new Date(new Date().getTime() + expiresIn * 1000).toLocaleString('es-PE', { timeZone: 'America/Lima' });

        // Llama a la mutación para almacenar el token y el tiempo de expiración y ahí se almacena también en el localStorage
        this.$store.commit('SET_TOKEN', { token, expiresIn });

        // Almacena en localStorage    
        localStorage.setItem('AccessToken', token)
        localStorage.setItem('tokenExpiration', expiresIn);
        // Guardar los timestamps en el LocalStorage
        localStorage.setItem('TokenCurrentTime', currentTime);
        localStorage.setItem('TokenExpirationTime', expirationTime);        

        // Mostrar mensaje de "Bienvenida"     
        this.mensaje_bienvenida()

        this.isLoading = false;
        this.$router.push('/')
      })
        .catch(error => {
          if (error.response && error.response.status === 401) {
            this.isLoading = false;
            this.mensaje_noautorizado()
            this.$session.destroy()
            localStorage.clear()
            this.$router.push('/login')
          }
        })
    },
    toggleLoading() {
      this.loading = (this.loading === '') ? 'loading' : ''
    },
    resetResponse() {
      this.response = ''
    },
    cargaData() {
      swal({
        title: "Iniciando sesión",
        text: "Cargando datos de acceso",
        buttons: false,
        dangerMode: true,
        icon: "static/img/loader.gif",
        closeOnClickOutside: false,
      })
    },
    errorUser() {
      swal({
        title: "Error con usuario",
        text: "No cuenta con permisos para acceder",
        buttons: false,
        dangerMode: true,
        icon: "error"
      })
    },

  },
  components: {
    Loading
  }
}
</script>

<style scoped>
html,
body,
.container-table {
  height: 100%;
  background-color: #d2d6de !important;
}

.swal-title {
  padding: 17px;
  display: block;
  margin: 23px;
  color: #424343;
  font-weight: bold;
  font-family: Arial;
}

.swal-text {
  padding: 17px;
  border: 1px solid #d3d9dd;
  display: block;
  margin: 23px;
  color: #566573;
  letter-spacing: 1px;
}

/* Estilos para el mensaje de Usuario No Autorizado */
.unauthorized-message {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #d0e0ee;
  color: #080101;
  padding: 20px;
  border: 1px solid rgb(30, 49, 104);
  border-radius: 5px;
  z-index: 1000;
  width: 300px;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 1px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
</style>


// WEBPACK FOOTER //
// Login.vue?ef16bd02